import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import db from "./Firebase";
import { collection, onSnapshot } from "firebase/firestore";
import Moment from "moment";
import ViewFormModal from "./ViewFormModal"; // ✅ Import modal
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const moment = Moment;

function FormRegistrationStatus() {
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(db, "registration_form_data"),
      (snapshot) => {
        const sortedData = snapshot.docs
          .map((docSnap) => ({
            id: docSnap.id,
            data: docSnap.data(),
          }))
          .sort((a, b) => {
            const aTime = a.data.createdAt?.toDate().getTime() || 0;
            const bTime = b.data.createdAt?.toDate().getTime() || 0;
            return bTime - aTime;
          });
        setData(sortedData);
      },
      (error) => {
        console.error("Error fetching data:", error);
        Swal.fire("Error", "Failed to load data", "error");
      }
    );

    return () => unsubscribe();
  }, []);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleView = (record) => {
    setSelectedRecord(record);
    setModalShow(true);
  };

  const filteredData = data.filter(({ data: d }) => {
    const phone = d.contact1 || "";
    return phone.toLowerCase().includes(searchQuery.toLowerCase());
  });


      const handleDownloadExcel = () => {
          if (!data.length) {
              Swal.fire("No Data", "No records available to export.", "info");
              return;
          }
  
          // 1️⃣ Flatten and merge all keys dynamically
          const allKeys = new Set();
          data.forEach(({ data: d }) => {
              Object.keys(d).forEach((key) => allKeys.add(key));
          });
  
          // 2️⃣ Convert Firestore objects to plain rows
          const exportData = data.map(({ id, data: d }, index) => {
              const row = { "Sr No": index + 1, "Document ID": id };
              allKeys.forEach((key) => {
                  let value = d[key];
  
                  // Handle arrays (like documents)
                  if (Array.isArray(value)) {
                      value = value.join(", ");
                  }
  
                  // Handle Firestore timestamps
                  if (value && typeof value === "object" && value.seconds) {
                      try {
                          const dateObj = new Date(value.seconds * 1000);
                          value = Moment(dateObj).format("YYYY-MM-DD HH:mm:ss");
                      } catch {
                          value = JSON.stringify(value);
                      }
                  }
  
                  row[key] = value ?? "";
              });
              return row;
          });
  
          // 3️⃣ Create Excel Sheet
          const worksheet = XLSX.utils.json_to_sheet(exportData, { origin: "A1" });
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "RegistrationData");
  
          // 4️⃣ Download File
          const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
          const blob = new Blob([excelBuffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, `registration_form_data_${Moment().format("YYYYMMDD_HHmmss")}.xlsx`);
      };

  return (
    <>
    <div style={{padding:"1rem"}}>
      {/* Header */}

         <div
                    className="p-2"
                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                >
                    <h5 className="mb-0">Registration Form Status (Count: {data.length})</h5>

                    {/* ✅ DOWNLOAD BUTTON */}
                    <button
                        onClick={handleDownloadExcel}
                        className="btn btn-success btn-sm"
                        style={{ whiteSpace: "nowrap" }}
                    >
                        📥 Download Excel
                    </button>
                </div>

                
      <div
        className="p-2"
        style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
      >
       
    
      </div>

      {/* Search & Table */}
      <div className="p-3">
 

        <input
          type="text"
          className="form-control form-control-sm mb-2"
          placeholder="Search by phone no..."
          value={searchQuery}
          onChange={handleSearch}
        />

        <div className="table-responsive fix-width scroll-inner">
          <table className="table table-bordered table-hover">
            <thead
              className="thead-dark"
              style={{ position: "sticky", top: 0, zIndex: 1 }}
            >
              <tr>
                <th>Sr. No</th>
                <th>Name</th>
                <th>Phone No</th>
                <th>Created Date</th>
                <th>Status</th>
                <th>Remarks</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map(({ id, data: d }, index) => (
                <tr key={id}>
                  <td>{index + 1}</td>
                  <td>{d.applicantName || "-"}</td>
                  <td>{d.contact1 || "-"}</td>
                  <td>
                    {d.createdAt
                      ? moment(d.createdAt.toDate()).format("DD/MM/YY, h:mm a")
                      : "-"}
                  </td>

                  {/* STATUS BADGE */}
                  <td>
                    <span
                      className={`badge ${
                        d.status === "Approved"
                          ? "bg-success"
                          : d.status === "Pending"
                          ? "bg-warning text-dark"
                          : "bg-secondary"
                      }`}
                      style={{ fontSize: "0.85rem", padding: "6px 10px" }}
                    >
                      {d.status || "Pending"}
                    </span>
                  </td>

                  {/* REMARK (READ ONLY) */}
               <td style={{ maxWidth: "250px", verticalAlign: "middle" }}>
                <textarea
                    className="form-control border-0 bg-light"
                    value={d.remarks || ""}
                    readOnly
                     style={{  backgroundColor: "#f8f9fa",resize: "both", minHeight: "40px", height: "40px" }}
                
                    ref={(el) => {
                    if (el) {
                        el.style.height = "auto"; // reset height
                        el.style.height = el.scrollHeight + "px"; // adjust to content
                    }
                    }}
                />
                </td>


                  {/* ACTION BUTTON */}
                  <td>
                    <button
                      className="btn btn-sm btn-info text-white"
                      onClick={() => handleView({ id, data: d })}
                    >
                      View Form
                    </button>
                    {d.status == "Approved" ? <> 
                    
                     <Link target="_blank" to={`/form.html?id=${id}`}
                      className="btn btn-sm btn-success text-white ml-3"
                      
                    >
                      Download PDF
                    </Link>
{/* <Link
  target="_blank"
  to={`/form.html?data=${encodeURIComponent(
    JSON.stringify(
      Object.fromEntries(
        Object.entries(d).map(([key, value]) => [
          key,
          typeof value === "string" && value.includes("firebasestorage.googleapis.com")
            // Encode the folder slash and spaces explicitly
            ? value.replaceAll("/o/form_uploads/", "/o/form_uploads%2F").replaceAll(" ", "%20")
            : value,
        ])
      )
    )
  )}`}
  className="btn btn-sm btn-success text-white ml-3"
>
  Download PDF
</Link> */}



                    
                    </> : <> <Link to={`/formedit/${id}`}
                      className="btn btn-sm btn-info text-white ml-3"
                      onClick={() => handleView({ id, data: d })}
                    >
                      Edit Form
                    </Link></>}
                     
                  </td>
                </tr>
              ))}

              {filteredData.length === 0 && (
                <tr>
                  <td colSpan="7" className="text-center text-muted">
                    No records found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      
      </div>
      {/* Modal */}
      <ViewFormModal
        show={modalShow}
        record={selectedRecord}
        onClose={() => {
          setModalShow(false);
          setSelectedRecord(null);
        }}
      />
    </>
  );
}

export default FormRegistrationStatus;



// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import Swal from "sweetalert2";
// import db from "./Firebase";
// import { doc, updateDoc, collection, onSnapshot } from "firebase/firestore";
// import Moment from "moment";
// import ViewFormModal from "./ViewFormModal"; // ✅ this should be here, not inside the component or after code

// const moment = Moment; // or extend if needed



// function FormRegistrationStatus() {
//     const [data, setData] = useState([]);
//     const [searchQuery, setSearchQuery] = useState("");
//     const [remarks, setRemarks] = useState({});

//     const [modalShow, setModalShow] = useState(false);
//     const [selectedRecord, setSelectedRecord] = useState(null);

//     useEffect(() => {
//         const unsubscribe = onSnapshot(
//             collection(db, "registration_form_data"),
//             (snapshot) => {
//                 const sortedData = snapshot.docs.map(docSnap => ({
//                     id: docSnap.id,
//                     data: docSnap.data()
//                 })).sort((a, b) => {
//                     const aTime = a.data.createdAt?.toDate().getTime() || 0;
//                     const bTime = b.data.createdAt?.toDate().getTime() || 0;
//                     return bTime - aTime;
//                 });
//                 setData(sortedData);

//                 const initialRemarks = {};
//                 sortedData.forEach(({ id, data }) => {
//                     initialRemarks[id] = data.remarks || "";
//                 });
//                 setRemarks(initialRemarks);
//             },
//             (error) => {
//                 console.error("Error fetching data:", error);
//             }
//         );

//         return () => unsubscribe();
//     }, []);

//     const handleSearch = (e) => {
//         setSearchQuery(e.target.value);
//     };

//     const handleStatusChange = async (id, newStatus) => {
//         try {
//             const docRef = doc(db, "registration_form_data", id);
//             await updateDoc(docRef, { status: newStatus });
//             Swal.fire("Success", "Status updated!", "success");
//         } catch (error) {
//             console.error("Error updating status:", error);
//             Swal.fire("Error", "Failed to update!", "error");
//         }
//     };

//     const handleRemarksChange = (id, value) => {
//         setRemarks(prev => ({ ...prev, [id]: value }));
//     };

//     const saveRemarks = async (id) => {
//         try {
//             const docRef = doc(db, "registration_form_data", id);
//             await updateDoc(docRef, { remarks: remarks[id] });
//             Swal.fire("Success", "Remarks updated!", "success");
//         } catch (error) {
//             console.error("Error updating remarks:", error);
//             Swal.fire("Error", "Failed to update!", "error");
//         }
//     };

//     const handleView = (record) => {
//         setSelectedRecord(record);
//         setModalShow(true);
//     };

//     const filteredData = data.filter(({ data: d }) => {
//         const phone = d.contact1 || "";
//         return phone.toLowerCase().includes(searchQuery.toLowerCase());
//     });

//     return (
//         <>
//             <div className="p‑2" style={{ display: "flex", justifyContent: "space‑between" }}>
//                 <Link to="/">
//                     <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
//                 </Link>
//             </div>

//             <div className="p‑3">
//                 <div className="card-header pb‑0 px‑3">
//                     <h6 className="mb‑2">All Registration Data ‑ (Count: {data.length})</h6>
//                 </div>

//                 <input
//                     type="text"
//                     className="form-control form-control-sm mb‑2"
//                     placeholder="Search by phone no..."
//                     value={searchQuery}
//                     onChange={handleSearch}
//                 />

//                 <div className="table-responsive fix‑width scroll‑inner">
//                     <table className="table table-bordered table-hover">
//                         <thead className="thead-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
//                             <tr>
//                                 <th>Sr. No</th>
//                                 <th>Name</th>
//                                 <th>Phone No</th>
//                                 <th>Created Date</th>
//                                 <th>Status</th>
//                                 <th>Remarks</th>
//                                 <th>View Form</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {filteredData.map(({ id, data: d }, index) => (
//                                 <tr key={id}>
//                                     <td>{index + 1}</td>
//                                     <td>{d.applicantName || ""}</td>
//                                     <td>{d.contact1 || ""}</td>
//                                     <td>{d.createdAt ? moment(d.createdAt.toDate()).format("DD/MM/YY, h:mm a") : "-"}</td>
//                                     <td>
//                                         <select
//                                             className="form-control"
//                                             value={d.status || "Pending"}
//                                             onChange={(e) => handleStatusChange(id, e.target.value)}
//                                         >
//                                             <option value="Pending">Pending</option>
//                                             <option value="Approved">Approved</option>
//                                         </select>
//                                     </td>
//                                     <td>
//                                         <div className="d-flex align-items-center gap-2">
//                                             <textarea
//                                                 className="form-control"
//                                                 placeholder="Enter remarks..."
//                                                 style={{ resize: "both", minHeight: "40px" }}
//                                                 value={remarks[id] || ""}
//                                                 onChange={(e) => handleRemarksChange(id, e.target.value)}
//                                                 onKeyDown={(e) => e.key === "Enter" && saveRemarks(id)}
//                                             />
                                          
//                                         </div>
//                                     </td>


//                                     <td>

//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>

//             <ViewFormModal
//                 show={modalShow}
//                 record={selectedRecord}
//                 onClose={() => {
//                     setModalShow(false);
//                     setSelectedRecord(null);
//                 }}
//             />
//         </>
//     );
// }

// export default FormRegistrationStatus;